export const name = 'gzBodyWrap';

/**
 * @ngdoc directive
 * @name gazelle.components.bodyWrap.directive:gzBodyWrap
 *
 * @param {string=} title If present, sets the application title in the left portion of the mini-bar.
 * @param {object=} nav-items If present, defines the set of application navigational items in the app-nav.
 *
 * @description
 * `<gz-body-wrap>` is a frame component convenience directive that simply wraps the application body and invokes the other frame directives in the
 * proper order and hierarchy.
 * There can only be one gz-body-wrap on a page and it should be immediately follow the body tag.
 *
 * @usage
 * ```html
 * <gz-body-wrap title="App Title" nav-items="nav_items_properties"></gz-body-wrap>
 * ```
 */
export default function gzBodyWrap($log) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'EA',
    scope: {
      title: '@',
      appTitle: '@',
      navItems: '&',
      headless: '=?',
      theme: '@',
    },
    template: require('./body-wrap.jade'),
    link: gzBodyWrapLink,
    controller: gzBodyWrapController,
    controllerAs: 'vm',
    bindToController: true
  };

  return directive;


  // /////////////////
  // // private functions

  function gzBodyWrapLink(scope, element, attrs) {
    if (attrs.appTitle === undefined) {
      // $log.warn('appTitle is undefined. Set the app title using the app-title attribute.');
      attrs.appTitle = attrs.title;
      element.removeAttr('title');
    }
    if (attrs.theme === undefined) {
      // $log.warn('appTitle is undefined. Set the app title using the app-title attribute.');
      element.removeAttr('theme');
    }
    if (attrs.title !== undefined) {
      // $log.warn('Using title to set the app title has been deprecated. Please use app-title.');
    }

    proxyBlueAttrs(scope, element, attrs);
  }

  function proxyBlueAttrs(scope, element, attrs) {
    let printosHeader = element.find('printos-header');

    if ('allowAnonymous' in attrs) {
      printosHeader.attr('allow-anonymous', '');
    }

    if ('headless' in attrs && scope.vm.headless === true) {
      printosHeader.attr('headless', true);
    }

    if (attrs.appId) {
      printosHeader.attr('app-id', attrs.appId);
    }
  }


  //* @ngInject
  function gzBodyWrapController() {
  }

} //gzBodyWrap
